<template>
  <div class="component">
    <b-container data-testid="addViewSiteDocumentContainer" fluid class="pt-25" v-if="siteId || !isUserSiteTeamMember">
      <addViewSiteDocument :siteId="siteId" :isAdmin="isAdmin" returnTo="study-participant-documents"></addViewSiteDocument>
    </b-container>
  </div>
</template>
<script>
import addViewSiteDocument from "@/components/common/add-view-site-document";
import localStorageService from "@/services/localStorage";
import { isSiteTeamRole } from "@/services/rolesService";
import { mapGetters } from "vuex";

export default {
  name: "study-participant-documents",
  components: {
    addViewSiteDocument
  },
  data() {
    return {
      studyId: this.$route.params.studyId,
      siteId: null,
      isAdmin: false
    };
  },
  computed: {
    ...mapGetters(["user"]),
    isUserSiteTeamMember() {
      return isSiteTeamRole(this.user.userRole);
    }
  },
  methods: {
    getSiteId() {
      if (this.isUserSiteTeamMember) {
        const user = localStorageService.getItem("userObj");
        this.siteId = user.siteIds[0];
      }
    }
  },
  mounted() {
    this.getSiteId();
  }
};
</script>
